import { BiteLogExpoPrinterEvent } from './bite_log_expo_printer_event.js';

export function name(event: BiteLogExpoPrinterEvent): string {
  switch (event) {
    case BiteLogExpoPrinterEvent.GetPrintJobsSuccessWithOrders:
      return 'get-print-jobs-success-with-orders';
    case BiteLogExpoPrinterEvent.SetPrintResponse:
      return 'set-print-response';
  }
}
